import axios from "axios";
import { BASE_URL } from "../_constants/urlConstants";
import { EQUIPMENT } from "../_constants/actionConstants";
import raiseError from "./raiseError";

const getAll = (projectId) => async (dispatch) => {
  dispatch({ type: EQUIPMENT.FETCH_ALL });
  const apiEndpoint = `${BASE_URL}/api/Equipment/List/${projectId}`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: EQUIPMENT.FETCH_ALL_FULFILLED,
      projEquipList: res.data,
      projectId,
    });
    return res.data;
  } catch (err) {
    raiseError(EQUIPMENT.FETCH_ALL_REJECTED, err.response.data);
  }
};

const getDetails = (equipmentId, projectId) => async (dispatch) => {
  dispatch({ type: EQUIPMENT.FETCH_DETAILS });
  const apiEndpoint = `${BASE_URL}/api/Equipment/${equipmentId}`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: EQUIPMENT.FETCH_DETAILS_FULFILLED,
      equipmentId,
      projectId,
      equipmentDetails: res.data,
    });
  } catch (err) {
    raiseError(EQUIPMENT.FETCH_DETAILS_REJECTED, err.response.data);
  }
};

const downloadAll = (projId) => async (dispatch) => {
  dispatch({ type: EQUIPMENT.GENERIC_REQUEST });
  const apiEndpoint = `${BASE_URL}/api/Equipment/AsCsv/${projId}`;
  try {
    const response = await axios.get(apiEndpoint);
    dispatch({ type: EQUIPMENT.GENERIC_REQUEST_FULFILLED });
    const file = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "equipment.csv");
    document.body.appendChild(link);
    link.click();
    return;
  } catch (err) {
    raiseError(EQUIPMENT.GENERIC_REQUEST_REJECTED, err.response.data);
  }
};

const add = (newEquipData) => async (dispatch) => {
  dispatch({ type: EQUIPMENT.ADD });
  const apiEndpoint = `${BASE_URL}/api/Equipment`;
  try {
    const res = await axios.post(apiEndpoint, newEquipData);
    dispatch({
      type: EQUIPMENT.ADD_FULFILLED,
      projectId: newEquipData.projectId,
    });
    return res.data;
  } catch (err) {
    raiseError(EQUIPMENT.ADD_REJECTED, err.response.data);
  }
};

const deleteEquipment = (equipmentId, projectId) => async (dispatch) => {
  dispatch({ type: EQUIPMENT.DELETE });
  const apiEndpoint = `${BASE_URL}/api/Equipment/${equipmentId}`;
  try {
    const res = await axios.delete(apiEndpoint);
    dispatch({ type: EQUIPMENT.DELETE_FULFILLED });
    dispatch({ type: EQUIPMENT.CLEAR_DETAILS, equipmentId, projectId });
  } catch (err) {
    raiseError(EQUIPMENT.DELETE_REJECTED, err.response.data);
  }
};

const update = (equipData) => async (dispatch) => {
  dispatch({ type: EQUIPMENT.EDIT });
  const apiEndpoint = `${BASE_URL}/api/Equipment`;
  try {
    const res = await axios.put(apiEndpoint, equipData);
    dispatch({
      type: EQUIPMENT.EDIT_FULFILLED,
      projectId: equipData.projectId,
      equipmentId: equipData.equipmentId,
      equipmentDetails: res.data,
    });
    return res.data;
  } catch (err) {
    raiseError(EQUIPMENT.EDIT_REJECTED, err.response.data);
  }
};

const hasLinks = (equipmentId) => async (dispatch) => {
  dispatch({ type: EQUIPMENT.GENERIC_REQUEST });
  const apiEndpoint = `${BASE_URL}/api/Equipment/${equipmentId}/HasLinks`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({ type: EQUIPMENT.GENERIC_REQUEST_FULFILLED });
    return res.data; // bool value
  } catch (err) {
    raiseError(EQUIPMENT.GENERIC_REQUEST_REJECTED, err.response.data);
  }
};

const uploadCsv = (projectId, equipmentList) => async (dispatch) => {
  dispatch({ type: EQUIPMENT.GENERIC_REQUEST });
  const apiEndpoint = `${BASE_URL}/api/Equipment/UploadCsv`;
  try {
    const res = await axios.post(apiEndpoint, equipmentList);
    dispatch({
      type: EQUIPMENT.ADD_FULFILLED,
      projectId,
    });
    return res.data;
  } catch (err) {
    raiseError(EQUIPMENT.GENERIC_REQUEST_REJECTED, err.response.data);
    return { success: false, message: err.response?.data?.message || "Upload failed" };
  }
};

// Keep this interface alphabetical
const equipmentActions = {
  add,
  deleteEquipment,
  downloadAll,
  getDetails,
  getAll,
  hasLinks,
  update,
  uploadCsv,
};

export default equipmentActions;
